/**
 * The new Saudi Riyal symbol (SAMA, 2025).
 * Rendered as a CSS mask over /riyal.png so it inherits the surrounding
 * text colour and size (works in dark mode, hover states, etc).
 */
export default function Riyal({ className = "" }: { className?: string }) {
  return <span role="img" aria-label="ريال سعودي" className={`riyal ${className}`} />;
}
